import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import FaqComponents from "../../components/common/faq";

const faqs = [
  {
    question: "What services does your game development company provide?",
    answer: `<p>The services that TekRevol offers as a game development company in London include game art creation, UX/UI creation, sound and music integration, and development services for iOS and Android platforms (planning and creation of NFT projects from scratch, integration services, testing, and maintenance).</p>`,
  },
  {
    question: " What types of games do you specialize in developing?",
    answer: ` <p>TekRevol specializes in building a diverse range of games including action games, role-playing games (RPGs), adventure games, simulation games, strategy games, sports games, casual games, puzzle games, indie games, and multiplayer games.</p>`,
  },
  {
    question: "How long does it typically take to develop a game?",
    answer: ` <p>Mobile games can be made in 3 months to 1 year. AAA games can even take up to 2 - 4 years. However, it totally depends on the type of the game.</p>`,
  },
  {
    question: " What technologies and platforms do you work with?",
    answer: ` <p>TekRevol uses the Unity 3D game engine to develop games of all kinds.</p>`,
  },
  {
    question:
      "Do you provide post-launch support and maintenance for the games you develop?",
    answer: `<p>Yes, TekRevol provides post-launch support and maintenance for the games we develop. As a top-tier game development company in London, our commitment extends beyond the launch phase to ensure the continued success and optimal performance of your game.</p>`,
  },
  {
    question: " How can I get started with your game development services?",
    answer: `<p>To get started with our game development services at TekRevol, simply reach out to our team through the contact form on our website or give us a call. As one of the best UK game studios, our experienced professionals are ready to discuss your game development needs, understand your vision, and guide you through the initial steps to kickstart the exciting journey of bringing your gaming ideas to life.</p>`,
  },
];

function FaqLocation(props) {
  return (
    <div className="faq_loc p-100 tekrevol_dark_bg">
      <Container className="h-100">
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <div className="example center text-center" data-text="FAQs">
              <h2>Frequently Asked Questions</h2>
            </div>
          </Col>
        </Row>
        <Row className="h-100">
          <Col
            xs={12}
            md={12}
            lg={12}
            xl={12}
            xxl={12}
            className="services_faqs"
          >
            <FaqComponents faqs={faqs} />
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default FaqLocation;
